import { render, staticRenderFns } from "./AppointmentType.vue?vue&type=template&id=720982bf&"
import script from "./AppointmentType.vue?vue&type=script&lang=js&"
export * from "./AppointmentType.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentType.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AppointmentType.vue"
export default component.exports